import { toLower } from "lodash";

export const isMockedDataEnabled = () => {
  return toLower(process.env.VUE_APP_MOCKED_DATA) === "true";
};
